
import React from "react";
import { isGDPREnabled } from "../../../../util/gdprUtils";
import { getL } from "../../../../util/lib";

export const GDPRBridgeHOC = (WrappedComponent) => {
    const tcData = getL('cmp-tcdata'),
        gdprEnabled = isGDPREnabled(tcData);
    // debugLog("GDPRBridgeHOC", GDPRProvider);
    return (props) => {
        return <WrappedComponent
            gdprEnabled={gdprEnabled}
            tcData={tcData}
            {...props} />
    }
}